import { useState } from "react";
import emailjs from "emailjs-com";

export default function QuoteForm() {
  const [status, setStatus] = useState(null);

  function sendEmail(e) {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm(
        "service_sdsffwz",      
        "template_dntl0vk",     
        e.target,
        "eKj0oRAWvQFnWM6XM"       
      )
      .then(() => {
        setStatus("success");
        e.target.reset();
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        setStatus("error");
      });
  }

  return (
    <section id="cotizacion" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Solicita tu Cotización</h2>
          <p className="text-xl text-gray-600">Te contactamos en menos de 24 horas</p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 shadow-lg border">
          
          <form className="space-y-6" onSubmit={sendEmail}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Input name="nombre" label="Nombre Completo *" placeholder="Ingresa tu nombre" required />
              <Input name="institucion" label="Institución *" placeholder="Nombre de tu hospital o clínica" required />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Input name="correo" type="email" label="Correo Electrónico *" placeholder="tuemail@ejemplo.com" required />
              <Input name="telefono" type="tel" label="Teléfono *" placeholder="+506 7000 0000" required />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Productos de Interés *</label>
              <textarea 
                name="productos"
                required
                className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
                rows={4}
                placeholder="Escriba el nombre o código del modelo de los equipos que desea cotizar (Evite incluir datos de salud)"
              ></textarea>
            </div>

            <div className="flex items-center space-x-3">
              <input type="checkbox" id="privacy" name="privacy" className="w-4 h-4" required />
              <label htmlFor="privacy" className="text-sm text-gray-600">
                Acepto la política de privacidad
              </label>
            </div>

            <button type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-lg text-lg shadow-lg font-bold transition"
            >
              {status === "sending" ? "Enviando..." : "Enviar Cotización"}
            </button>

            {/* Mensaje de confirmación */}
            {status === "success" && (
              <p className="text-green-600 font-semibold mt-4 text-center">
                ¡Cotización enviada correctamente! Te contactaremos pronto.
              </p>
            )}
            {status === "error" && (
              <p className="text-red-600 font-semibold mt-4 text-center">
                Hubo un error al enviar la cotización. Intenta de nuevo.
              </p>
            )}
          </form>

        </div>
      </div>
    </section>
  );
}

function Input({ label, type = "text", placeholder, name, required }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
}
